import { put } from 'redux-saga/effects'
import { IPcr } from '../../pcr/store/pcr.types'
import { setAssessmentSeq, setAssessmentsList } from '../store/additionalAssessments.actions'
import { setAssessmentSeq as setBodyAssessmentSeq } from '../bodyAssessment/bodySurvey/store/bodySurvey.actions'

export function* getAssessments(pcrDoc: IPcr) {
  const assessments = pcrDoc.additionalAssessment?.bodySurveys
  if (assessments && assessments.length) {
    const lastAssessment = assessments[assessments.length - 1]
    const sequence = lastAssessment.seq
    yield put(setAssessmentSeq(sequence))
    yield put(setBodyAssessmentSeq(sequence))
    yield put(setAssessmentsList(assessments))
  }
}
